/*
 * @Descripttion: 
 * @version: 0.1.0
 * @Author: wangcan
 * @Date: 2023-03-29 11:36:05
 * @LastEditors: wangcan
 * @LastEditTime: 2023-03-30 17:47:58
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'

// import './assets/css/common.css'
// import Vant from 'vant';
import 'vant/lib/index.css';
import '../src/common/flexbie'

import VueCookie from 'vue-cookie'  


import { Toast } from 'vant';
import { Image as VanImage } from 'vant';
import { NavBar } from 'vant';
import { Tag } from 'vant';
import { Empty } from 'vant';
import { Button } from 'vant';
import { Form } from 'vant';
import { Field } from 'vant';
import {  RadioGroup, Radio ,Cascader,Popup,Uploader,Picker } from 'vant';
Vue.use(Toast).use(VanImage).use(NavBar).use(Tag).use(Empty).use(Button).use(Form).use(Field).use(Radio).use(RadioGroup).use(Cascader).use(Popup).use(Uploader).use(Picker).use(VueCookie);
//axios全局应用
// import htp from './untils/axios.js'
import htp from './utils/httpRequest.js'
Vue.prototype.$htp = htp

Vue.config.productionTip = false

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
